import { render, staticRenderFns } from "./ProfitChart.vue?vue&type=template&id=8980ad9a&scoped=true&"
import script from "./ProfitChart.vue?vue&type=script&lang=js&"
export * from "./ProfitChart.vue?vue&type=script&lang=js&"
import style0 from "./ProfitChart.vue?vue&type=style&index=0&id=8980ad9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8980ad9a",
  null
  
)

/* custom blocks */
import block0 from "./ProfitChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardSubtitle,VSkeletonLoader,VTooltip})
